<div class="ec-input-group"
     [ngClass]="{ 'hidden': isDisabled && hideDisabled, 'required': required && !isDisabled }">
  <div>
    <ng-container *ngTemplateOutlet="label"></ng-container>
    @if (required) {
      <span class="text-red-700 font-bold text-sm">*</span>
    }
  </div>
  <div>
    <ng-container *ngTemplateOutlet="helpText"></ng-container>
  </div>
  <div class="relative">
    <ng-container *ngTemplateOutlet="input"></ng-container>
    <div class="text-sm">
      <ng-content></ng-content>
    </div>
  </div>
  <div>
    <ng-container *ngTemplateOutlet="error"></ng-container>
  </div>
</div>


<!-- Label -->
<ng-template #label>
  <ng-content select="[appLabel]"></ng-content>
</ng-template>

<!-- Input -->
<ng-template #input>
  <ng-content select="input[appInput], input[appDate], select[appSelect], textarea[appTextarea], app-radio, app-checkbox, app-color, [appInputValue]">
  </ng-content>
</ng-template>

<!-- Group -->
<ng-template #group>
  <ng-content select="[appGroup], [appValue]"></ng-content>
</ng-template>

<!-- HelpText -->
<ng-template #helpText>
  <ng-content select="[appHelp]"></ng-content>
</ng-template>

<!-- Error -->
<ng-template #error>
  @if (formControl && formControl.errors && formControl['touched']) {
    <app-input-error [errors]="formControl.errors"></app-input-error>
  }
</ng-template>
